import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { ref: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "m-costcalc-block__header row spacing-bottom-2-xs"
}
const _hoisted_3 = { class: "col-md-7 col-lg-8 col-xs-12" }
const _hoisted_4 = { class: "a-steps__title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "a-steps" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "step step--active" }, null, -1)
const _hoisted_8 = { class: "m-costcalc-block__content row justify-content-between-xs align-left-xs" }
const _hoisted_9 = { class: "col-md-7 col-lg-8 col-xs-12" }
const _hoisted_10 = { class: "flow" }
const _hoisted_11 = {
  key: 2,
  class: "flow__content"
}
const _hoisted_12 = { class: "spacing-top-3-xs spacing-bottom-3-xs" }
const _hoisted_13 = { class: "editable-header spacing-bottom-1-xs spacing-bottom-2-sm" }
const _hoisted_14 = { class: "m-content-section__subtitle" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 3,
  class: "alert alert--error"
}
const _hoisted_17 = {
  key: 4,
  class: "flow__nav"
}
const _hoisted_18 = { class: "m-costcalc-nav" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "-4 -2.5 15 15",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.265 10.032a.726.726 0 00.511-.205.686.686 0 000-.991L1.74 5.015l4.016-3.801a.686.686 0 000-.991.738.738 0 00-1.022 0L.207 4.52a.686.686 0 000 .991l4.547 4.316c.137.133.32.206.511.205z",
    "fill-rule": "evenodd",
    fill: "currentColor"
  })
], -1)
const _hoisted_20 = { class: "" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "-1 -2.5 15 15",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.735-.032a.726.726 0 00-.511.205.686.686 0 000 .991L8.26 4.985 4.244 8.786a.686.686 0 000 .991.738.738 0 001.022 0L9.793 5.48a.686.686 0 000-.991L5.246.173a.727.727 0 00-.511-.205z",
      "fill-rule": "evenodd",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "-1 -2.5 15 15",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.735-.032a.726.726 0 00-.511.205.686.686 0 000 .991L8.26 4.985 4.244 8.786a.686.686 0 000 .991.738.738 0 001.022 0L9.793 5.48a.686.686 0 000-.991L5.246.173a.727.727 0 00-.511-.205z",
      "fill-rule": "evenodd",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_27 = { class: "m-costcalc-block__aside col-lg-4 col-md-5 col-xs-12" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "a-tip-costcalc"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "",
  id: "tip-step",
  value: ""
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "a-tip-costcalc__icon",
  for: "tip-step"
}, null, -1)
const _hoisted_32 = { class: "a-tip-costcalc__wrapper" }
const _hoisted_33 = { class: "a-tip-costcalc__title" }
const _hoisted_34 = { class: "a-tip-costcalc__text" }
const _hoisted_35 = {
  key: 1,
  class: "m-costcalc-block__intro spacing-top-3-xs spacing-bottom-3-md"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon--costcalc" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 187 272",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M149.47 221.49H37.91c-1.67 0-3.03 1.348-3.03 3.01 0 1.662 1.36 3.01 3.03 3.01h111.56c1.67 0 3.02-1.348 3.02-3.01 0-1.662-1.35-3.01-3.02-3.01zm2.88-40.364l-15.57 6.043h-.19a7.73 7.73 0 00-3.71 2.688 7.634 7.634 0 00-1.5 4.311v6.37h-27.96a10.33 10.33 0 00-3.76-5.388c-1.8-1.345-4-2.072-6.25-2.072-2.26 0-4.45.727-6.26 2.072a10.387 10.387 0 00-3.76 5.388h-28.9v-6.416a7.499 7.499 0 00-1.5-4.315 7.614 7.614 0 00-3.71-2.685l-15.55-6.043h-.21a8.909 8.909 0 00-3.46-.304 8.93 8.93 0 00-3.31 1.044 8.912 8.912 0 00-2.65 2.23 8.912 8.912 0 00-1.58 3.073l-2.77 7.303v.257a7.777 7.777 0 00-.13 3.589c.24 1.19.75 2.31 1.49 3.27a9.455 9.455 0 003.23 2.638c1.27.626 2.66.96 4.07.979l22.87 1.283h32.2a10.446 10.446 0 009.93 7.158c2.2 0 4.34-.692 6.12-1.978a10.387 10.387 0 003.8-5.18h31.29l22.96-1.307a9.372 9.372 0 004.05-.984 9.461 9.461 0 003.23-2.632 7.65 7.65 0 001.5-3.267 7.661 7.661 0 00-.14-3.593l-2.84-7.536a8.882 8.882 0 00-1.6-3.06 8.89 8.89 0 00-9.43-2.936zM48.46 200.328l-19.89-1.12h-.16c-.5-.005-.99-.121-1.44-.339a3.292 3.292 0 01-1.14-.921c-.17-.206-.3-.446-.36-.704a1.753 1.753 0 01-.02-.789l2.72-7.186c.28-.724 1.32-3.01 3.5-2.333l15.13 5.693c1.1.536 1.66 1.003 1.66 1.399v6.3zm44.95 7.35c-.87 0-1.71-.255-2.43-.732a4.312 4.312 0 01-1.6-1.947 4.31 4.31 0 01-.25-2.508 4.34 4.34 0 013.43-3.41 4.397 4.397 0 012.52.247c.79.329 1.47.885 1.95 1.599.48.713.74 1.552.74 2.411a4.32 4.32 0 01-1.28 3.068 4.379 4.379 0 01-3.08 1.272zm64.32-18.386l2.72 7.163c.04.263.03.533-.04.791-.06.258-.19.498-.36.702-.31.388-.69.703-1.14.921-.44.218-.93.334-1.42.339l-20.05 1.12v-6.206c0-.397.56-.864 1.64-1.4l15.15-5.88c2.18-.583 3.21 1.703 3.5 2.45z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M186.7 160.221l-2.84-7.513a8.815 8.815 0 00-1.59-3.084 8.951 8.951 0 00-2.65-2.242 8.94 8.94 0 00-6.79-.764l-14.07 5.437-6.62-13.883a30.12 30.12 0 00-10.42-12.082 30.362 30.362 0 00-15.17-5.09h-67.2a30.348 30.348 0 00-15.29 5.041 30.163 30.163 0 00-10.52 12.131l-6.42 13.509-12.83-4.993h-.22a8.924 8.924 0 00-3.46-.295c-1.16.13-2.29.487-3.32 1.05a8.928 8.928 0 00-2.65 2.235 8.775 8.775 0 00-1.59 3.077l-2.67 7.209v.233a7.78 7.78 0 00-.14 3.589 7.82 7.82 0 001.5 3.271 9.35 9.35 0 003.22 2.65c1.27.63 2.66.969 4.07.99l8.99.49-7.58 15.935a26.75 26.75 0 00-2.61 11.526v63.836c0 2.259.91 4.425 2.51 6.022A8.608 8.608 0 0016.4 271h13.02c2.27 0 4.46-.9 6.07-2.501a8.514 8.514 0 002.51-6.038v-9.473h10.18l7.51-4.363h75.51l7.53 4.48h9.26v8.282a9.7 9.7 0 002.85 6.855 9.792 9.792 0 006.89 2.851h10.67a9.812 9.812 0 006.89-2.849 9.719 9.719 0 002.87-6.857v-61.549a32.048 32.048 0 00-3.12-13.742L168 171.28l10.06-.56c1.41-.014 2.8-.35 4.06-.981a9.206 9.206 0 003.21-2.659 7.671 7.671 0 001.52-3.266 7.796 7.796 0 00-.15-3.593zM39.1 140.739a24.267 24.267 0 018.36-9.662 24.38 24.38 0 0112.14-4.081h66.69a24.31 24.31 0 0112.1 4.095 24.076 24.076 0 018.31 9.648l11.92 25.035-3.76.21H32.07l-4.86-.257 11.89-24.988zM9.2 164.63h-.17a3.291 3.291 0 01-2.56-1.236 1.9 1.9 0 01-.37-.713 1.682 1.682 0 01-.02-.804l2.74-7.163c.26-.723 1.29-3.033 3.47-2.449l12.43 4.876-3.91 8.213-11.61-.724zm160.39 24.032a26.197 26.197 0 012.51 11.176v47.154h-31.69l-7.55-4.503H54.02l-7.55 4.503h-32.7v-48.321a20.9 20.9 0 012.04-8.959l8.61-18.082 7.39.42H155.1l6.38-.42 8.11 17.032zm10.94-25.198c-.31.378-.7.685-1.15.899a3.36 3.36 0 01-1.41.337l-12.76.724-3.78-7.933 13.26-5.156c2.18-.584 3.23 1.726 3.49 2.473l2.74 7.139c.05.267.04.54-.03.802s-.19.506-.36.715zM126.51 51a24.127 24.127 0 01-13.62-4.206c-4.04-2.746-7.18-6.652-9.04-11.223a25.427 25.427 0 01-1.4-14.456 25.13 25.13 0 016.71-12.812c3.43-3.5 7.8-5.882 12.55-6.846 4.76-.965 9.69-.468 14.17 1.428a24.623 24.623 0 0111 9.222A25.427 25.427 0 01151 26.011c-.01 6.626-2.59 12.978-7.18 17.663-4.59 4.685-10.82 7.32-17.31 7.326zm0-43.116a17.492 17.492 0 00-9.87 3.044 18.041 18.041 0 00-6.56 8.13 18.481 18.481 0 00-1.02 10.476c.69 3.518 2.38 6.75 4.86 9.287a17.649 17.649 0 009.09 4.968c3.45.701 7.02.344 10.27-1.028a17.821 17.821 0 007.98-6.676 18.413 18.413 0 002.99-10.074c0-4.803-1.86-9.411-5.19-12.81-3.33-3.398-7.84-5.311-12.55-5.317z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M132.7 30.348l2.94 2.8a9.22 9.22 0 01-3.6 2.707 11.43 11.43 0 01-4.7.941 11.737 11.737 0 01-4.49-.895 10.286 10.286 0 01-3.62-2.57 9.96 9.96 0 01-2.25-3.855h-3.2v-2.455h2.81c-.01-.26-.01-.52 0-.78a10.75 10.75 0 010-.803h-2.81v-2.432h3.24a9.867 9.867 0 012.25-3.855 9.825 9.825 0 013.62-2.57c2.99-1.24 6.33-1.24 9.31 0a9.396 9.396 0 013.55 2.684l-2.94 2.8a6.609 6.609 0 00-2.28-1.718 6.483 6.483 0 00-2.78-.577 6.756 6.756 0 00-3.4.872 5.735 5.735 0 00-2.25 2.432h7.22v2.364h-8.07a5.38 5.38 0 000 .803c-.01.26-.01.52 0 .78h7.94v2.547h-7.22a5.663 5.663 0 002.25 2.41c1.03.59 2.21.891 3.39.871a6.37 6.37 0 002.83-.653 6.523 6.523 0 002.26-1.848zM65.48 63.911a24.799 24.799 0 01-26.62-7.151 24.799 24.799 0 01-5.94-13.128c-.63-4.867.19-9.812 2.37-14.211a24.782 24.782 0 019.86-10.501 24.793 24.793 0 0114.03-3.249 24.814 24.814 0 0121.85 16.827 24.816 24.816 0 01-1.28 18.921 24.775 24.775 0 01-14.27 12.492zM51.79 23.403a17.975 17.975 0 00-9.85 25.995 17.99 17.99 0 007.6 7.152 17.993 17.993 0 0019.82-2.573 18 18 0 005.53-8.858c.92-3.434.81-7.065-.33-10.434a17.983 17.983 0 00-22.77-11.282z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M55.19 41.567c.24-.845.58-1.66 1.01-2.43.25-.457.46-.932.65-1.42.1-.312.11-.65.01-.964a1.129 1.129 0 00-.32-.502 1.09 1.09 0 00-.52-.272 2.265 2.265 0 00-1.43.1c-.59.198-1.1.563-1.47 1.049a3.613 3.613 0 00-.75 1.767l-5.68-.675a8.365 8.365 0 012.15-4.355 11.367 11.367 0 014.9-2.979c1.88-.734 3.94-.893 5.9-.456.81.161 1.56.537 2.17 1.088.6.551 1.05 1.256 1.29 2.042.25.694.34 1.432.28 2.165a5.688 5.688 0 01-.46 1.765c-.28.609-.61 1.2-.97 1.767a11.57 11.57 0 00-.82 1.673c-.16.371-.17.786-.04 1.166l-5.71 1.931a3.99 3.99 0 01-.19-2.46zm2.62 8.941c-.43-.187-.8-.46-1.11-.802a3.235 3.235 0 01-.69-1.184 3.148 3.148 0 01-.18-1.36c.04-.46.18-.907.4-1.311a4.572 4.572 0 012.31-1.76c.95-.318 1.97-.32 2.91-.003.42.183.8.455 1.12.797.31.343.54.748.68 1.189.15.436.21.899.17 1.359-.04.46-.17.907-.4 1.311a4.262 4.262 0 01-5.21 1.764zm34.51 63.866A24.789 24.789 0 0179.3 108.2a24.86 24.86 0 01-7.39-12.367c-1.18-4.763-.93-9.77.73-14.388a24.844 24.844 0 018.6-11.556 24.834 24.834 0 0113.58-4.825c4.9-.23 9.76.999 13.97 3.532a24.765 24.765 0 019.64 10.698 24.817 24.817 0 012.08 14.257 24.78 24.78 0 01-9.79 16.242 24.796 24.796 0 01-18.4 4.581zm6.35-42.285a17.98 17.98 0 00-10.33 1.5 17.923 17.923 0 00-7.75 6.988 17.998 17.998 0 00-2.57 10.12 18.027 18.027 0 003.49 9.839 18 18 0 008.37 6.24 17.99 17.99 0 0010.43.536 17.943 17.943 0 008.96-5.348 17.95 17.95 0 004.49-9.428c.71-4.711-.49-9.511-3.31-13.345a18.001 18.001 0 00-11.78-7.102z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M101.55 95.05l2.54 3.189a9.395 9.395 0 01-4 2.114c-1.59.405-3.23.479-4.85.216a12.121 12.121 0 01-4.36-1.554 10.523 10.523 0 01-3.25-3.065 9.976 9.976 0 01-1.68-4.119l-3.2-.48.37-2.408 2.81.423c.02-.258.06-.513.11-.766.03-.264.07-.527.12-.787l-2.81-.423.36-2.385 3.24.487a9.609 9.609 0 012.82-3.443 9.876 9.876 0 014-1.976c3.17-.766 6.51-.264 9.32 1.401a9.653 9.653 0 013.16 3.167l-3.37 2.302a6.613 6.613 0 00-2.03-2.028 6.594 6.594 0 00-2.69-.983 6.956 6.956 0 00-3.53.344 5.755 5.755 0 00-2.61 2.048l7.23 1.085-.35 2.318-8.08-1.214c-.05.26-.09.523-.12.788-.05.252-.09.508-.11.765l7.94 1.194-.37 2.498-7.23-1.086a5.648 5.648 0 001.9 2.701 6.836 6.836 0 003.27 1.366 6.53 6.53 0 005.45-1.689z" })
  ])
], -1)
const _hoisted_37 = {
  key: 1,
  class: "m-costcalc-block section items-start"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "3",
  ry: "3",
  width: "100",
  height: "50"
}, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "alert alert--error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OwnCarTypeStep = _resolveComponent("OwnCarTypeStep")!
  const _component_KilometersStep = _resolveComponent("KilometersStep")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_CostsResult = _resolveComponent("CostsResult")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.translationResult.loaded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["m-costcalc-block section items-start", { 'm-costcalc-block--step': _ctx.showProgressBar }])
        }, [
          (_ctx.showProgressBar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("costs-calculator-steps-progress", { step: _ctx.step, steps: _ctx.totalSteps })), 1),
                      _hoisted_5
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", {
                      class: _normalizeClass(["step", { 'step--active': _ctx.isStep2 }])
                    }, null, 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.isStep1)
                  ? (_openBlock(), _createBlock(_component_OwnCarTypeStep, {
                      key: 0,
                      onChangeOwnCarType: _ctx.setOwnCarType,
                      ownCarType: _ctx.selectedOwnCarType
                    }, null, 8, ["onChangeOwnCarType", "ownCarType"]))
                  : (_ctx.isStep2)
                    ? (_openBlock(), _createBlock(_component_KilometersStep, {
                        key: 1,
                        onChangeKilometers: _ctx.setKilometers,
                        kilometers: _ctx.currentKilometers
                      }, null, 8, ["onChangeKilometers", "kilometers"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("h3", null, [
                                _createTextVNode(_toDisplayString(_ctx.$t("costs-calculator-title-compare")) + " ", 1),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("costs-calculator-title-costs")), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("costs-calculator-title-own-car-vs-greenwheels")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("p", {
                                innerHTML: _ctx.$t('costs-calculator-text')
                              }, null, 8, _hoisted_15)
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "a-button spacing-top-4-xs spacing-top-6-md text-center-xs",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateNext && _ctx.navigateNext(...args)))
                            }, _toDisplayString(_ctx.$t("button-start")), 1)
                          ])
                        ])
                      ])),
                (_ctx.error && !_ctx.errorInPopup)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.message || _ctx.$t("error-general-fault")), 1))
                  : _createCommentVNode("", true),
                (!_ctx.isHomeStep && !_ctx.isCalculated)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.step > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "o-buttonnav--prev",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigatePrevious && _ctx.navigatePrevious(...args)))
                            }, [
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, [
                                _createTextVNode(_toDisplayString(_ctx.$t("button-previous")), 1),
                                (_ctx.isStep2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, " " + _toDisplayString(_ctx.$t("button-previous-to-car-type")), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22)),
                        (_ctx.step < _ctx.totalSteps)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "o-buttonnav--next",
                              disabled: _ctx.currentStepValid,
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateNext && _ctx.navigateNext(...args)))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-next")), 1),
                              _hoisted_24
                            ], 8, _hoisted_23))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              type: "button",
                              class: "o-buttonnav--next",
                              disabled: _ctx.currentStepValid,
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.calculateCosts && _ctx.calculateCosts(...args)))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("button-calculate")), 1),
                              _hoisted_26
                            ], 8, _hoisted_25))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              (!_ctx.isHomeStep)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_ctx.hasTip)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _hoisted_30,
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("h4", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("tip")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.tipText), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("cost-calculator-image-text")), 1)
                    ])
                  ]))
            ])
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
          (!_ctx.translationResult.error)
            ? (_openBlock(), _createBlock(_component_content_loader, {
                key: 0,
                viewBox: "0 0 100 50"
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.translationResult.message), 1))
        ])),
    _createVNode(_component_CostsResult, {
      costs: _ctx.calculationResponse,
      loading: _ctx.processing,
      error: _ctx.error && _ctx.errorInPopup,
      message: _ctx.message,
      onPreviousStep: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetCalculationFlow(true))),
      onSubscribe: _cache[5] || (_cache[5] = ($event: any) => (_ctx.subscribe()))
    }, null, 8, ["costs", "loading", "error", "message"])
  ], 512))
}